/** @format */

import React from "react";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}

export default function Costinput({ chargeCredit, setChargeCredit }) {
  const handleChange = (event) => {
    setChargeCredit(Number(event.target.value));
  };

  return (
    <div className="w-full relative mt-4 {classes.root}">
      <TextField
        label="충전할 크레딧을 입력해 주세요"
        value={chargeCredit}
        onChange={handleChange}
        name="numberformat"
        id="formatted-numberformat-input"
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
        className="mr-3 w-full"
      />
      <p className="text-xs font-bold text-555 absolute top-8 right-3">Credit</p>
      <div className="flex justify-end items-center px-3 mt-3">
        <p className="text-555 text-xs mr-5">결제 금액</p>
        <p className="text-right">
          <span className="font-bold text-555 text-xl mr-2">{Number(chargeCredit) * 10}</span>
          <span className="text-555 text-xl">원</span>
        </p>
      </div>
    </div>
  );
}
